// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
    getSubGroupAccount,
    insertSubGroupAccount,
    subGroupAccountSelector,
    updateSubGroupAccount
} from './subGroupAccountSlice';


import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const SubGroupAccountPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const subGroupAccount = useSelector(
        subGroupAccountSelector
    );


    useEffect(() => {
        dispatch(getSubGroupAccount({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && subGroupAccount.isGetSuccess && !subGroupAccount.isGetFetching) {
            let calc = subGroupAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subGroupAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && subGroupAccount.isGetSuccess && !subGroupAccount.isGetFetching) {
            let calc = subGroupAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subGroupAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!subGroupAccount?.isGetFetching && subGroupAccount.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = subGroupAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subGroupAccount.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getSubGroupAccount({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (subGroupAccount.isGetSuccess) {
                alertService.success(subGroupAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getSubGroupAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (subGroupAccount.isUpdateSuccess) {
                alertService.success(subGroupAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateSubGroupAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetSubGroupAccount(params) {
    //   return dispatch(getSubGroupAccount(params));
    // }

    function handleInsertSubGroupAccount(param) {
        setInsertFetch(true);
        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccountID: param.dropdownSubAccountValue,
            SubGroupAccount: param.inputTwoValue,
            SubGroupAccountID: param.inputOneValue,
            SaldoNormal: param.dropdownNormalValue,
        };

        dispatch(insertSubGroupAccount(params));
    }

    function handleUpdateSubGroupAccount(param) {
        setUpdateFetch(true);

        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccountID: param.dropdownSubAccountValue,
            SubGroupAccount: param.inputOneValue,
            SubGroupAccountID: currentData.SubGroupAccountID,
            status: param.status,
            SaldoNormal: param.dropdownNormalValue,
        };
        dispatch(updateSubGroupAccount(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getSubGroupAccount(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getSubGroupAccount(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (subGroupAccount.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? subGroupAccount.count : newCount,
            search: search,
        }
        dispatch(getSubGroupAccount(params));

        setPage(1);
        setCount((newCount === "-1") ? subGroupAccount.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="SubGroupAccount"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Sub Group Account"
                                tableData={subGroupAccount.data}
                                colOneTitle="ID"
                                colOneData="SubGroupAccountID"
                                colTwoTitle="Nama Sub Group Account"
                                colTwoData="SubGroupAccount"
                                colThreeTitle="Group Account"
                                colThreeData="SubAccount"
                                colFourTitle="Saldo Normal"
                                colFourData="SaldoNormalKet"

                                status="Status"

                                fetching={subGroupAccount.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Sub Group Account"
                        dropdownMainAccount={true}
                        dropdownSubAccount={true}
                        dropdownNormal={true}
                        inputOneTitle="ID Sub Group Account"
                        inputOnePlaceholder=""
                        inputTwoTitle="Nama Sub Group Account"
                        inputTwoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertSubGroupAccount}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SubGroupAccountID}
                        modal={handleModal}
                        modalTitle="Ubah Sub Group Account"
                        dropdownMainAccount={true}
                        dropdownMainAccountValue={currentData.MainAccountID}
                        dropdownSubAccount={true}
                        dropdownSubAccountValue={currentData.SubAccountID}
                        dropdownNormal={true}
                        dropdownNormalValue={currentData.SaldoNormal}
                        inputOneTitle="Nama Sub Group Account"
                        inputOneValue={currentData.SubGroupAccount}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateSubGroupAccount}
                    />
                }
            </div>

        )
    }

}


export default SubGroupAccountPage;